module.exports = __webpack_public_path__ + "resources/images/studentenhuis-d6698bc6abd57622242ff597dc1925b5-cache.jpg";